export enum ETAPAS {
  DEFAULT = '0',
  PASO1 = '1',
  PASO2 = '2',
  PASO3 = '3',
  PASO4 = '4',
  PASO_TICKET_INGRESADO = 'TICKET_INGRESADO',
  PASO_TICKET_EN_PROCESO = 'TICKET_EN_PROCESO',
}
